import { Navigate, useLocation } from 'react-router-dom';

import { COURT_CASES_V2_ROUTES } from '../constants';

export function CourtCasesBaseRedirect() {
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={{ pathname: COURT_CASES_V2_ROUTES.CASES, search, hash }}
      replace
    />
  );
}
